<template>
    <tr class="estableshiment-table-item">
        <td class="col-sm">
            <app-toggle v-model="active"></app-toggle>
        </td>

        <td>
            {{ item.nameMaster }}
        </td>

        <td>
            {{ item.totalEstablishments }}
        </td>

        <td>
            {{ item.localAccount }}
        </td>

        <td>
            {{ item.accessPointCount }}
        </td>

        <td>
            {{ $date.format(item.registrationDate) }}
        </td>

        <td class="estableshiment-table-item-last_login">
            {{ lastLogin }}
        </td>

        <td class="edit">
            <i
                class="mdi mdi-settings pointer"
                v-tooltip="$t('message.generics.message.settings')"
                @click="settings"
            ></i>

            <svgicon
                class="pointer"
                icon="account-cog-outline"
                v-tooltip="'Permissões de Estabelecimento'"
                width="18"
                height="18"
                color="#707070"
                @click="isPermissionModalOpen = true"
            ></svgicon>

            <i
                class="mdi mdi-square-edit-outline pointer"
                v-tooltip="$t('message.generics.message.edit')"
                @click="edit"
            ></i>

            <i
                class="mdi mdi-eye pointer"
                v-tooltip="$t('message.admGenerics.message.access')"
                @click="access"
            ></i>
        </td>
        <app-confirmation-modal
            :value="!!pendingChangeActive"
            confirm-label="Confirmar"
            @confirm="confirmChangeActive"
            @cancel="cancelChangeActive"
        >
            <span slot="heading">
                {{ $t("message.admPartners.message.deactivatePartner") }}
            </span>
            <span>
                {{
                    $t("message.admPartners.message.confirmPartnerDeactivation")
                }}
            </span>

            <p v-html="alertMessage" class="deactivate-partner-alert"></p>
        </app-confirmation-modal>
        <partner-establishment-permissions-modal
            v-if="isPermissionModalOpen"
            v-model="isPermissionModalOpen"
            :partner-id="item.id"
            :manageable-permissions="manageablePermissions"
            @on-toggle="onPartnerEstablishmentPermissionToggle"
        />
    </tr>
</template>

<script>
import userTableItem from "@views/admin/mixins/user-table-item";
import EventBus from "@packages/event-bus";
import PartnerEstablishmentPermissionsModal from "./PartnerEstablishmentPermissionsModal.vue";

export default {
    components: {
        PartnerEstablishmentPermissionsModal,
    },
    data() {
        return {
            entity: "partners",
            showSms: false,
            isPermissionModalOpen: false,
            manageablePermissions: [...this.dataItem.managedPermissions],
        };
    },

    computed: {
        lastLogin() {
            return this.item.lastLogin
                ? this.$date.format(this.item.lastLogin)
                : "---";
        },

        alertMessage() {
            return this.$t(
                "message.admPartners.message.deactivatePartnerAlert"
            );
        },
    },

    mounted() {
        EventBus.$on("USER_CHECKS_CHANGED", this.updateUserAllowSms);
    },

    beforeDestroy() {
        EventBus.$off("USER_CHECKS_CHANGED", this.updateUserAllowSms);
    },

    methods: {
        updateUserAllowSms(data) {
            if (this.item.id === data.id) {
                this.item.permitirUtilizarSMS = data.checks.allowSms;
            }
        },
        onPartnerEstablishmentPermissionToggle({ permission, active }) {
            if (active) {
                this.manageablePermissions.push(permission);
            } else {
                this.manageablePermissions = this.manageablePermissions.filter(
                    (manageablePermission) =>
                        manageablePermission !== permission
                );
            }
        },
    },

    mixins: [userTableItem],
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.estableshiment-table-item {
    .estableshiment-table-item-last_login {
        text-align: center;
    }
}

.edit {
    .mdi {
        font-size: 18px;

        &:not(:last-child) {
            margin-right: 6px;
        }
    }

    svg {
        margin-right: 6px;
    }
}

.deactivate-partner-alert {
    margin: 0;
    margin-top: 16px;
    color: #ff4150;
    font-size: 12px;
}
</style>
